import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var loginRes;
export const loginTodo = createAsyncThunk('login', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'sign_in',
            data: {
                "email": data?.values?.email,
                "password": data?.values?.password
            },
            headers: { "Content-Type": "application/json" }
        })
        return loginRes = res

    } catch (error) {
        return loginRes = error.response
    }
})